import { request } from '@/lib/api';
import { exportNotesResponseSchema } from '@mss_creator/shared';
import type { ExportNotesSection } from '@mss_creator/shared';
import { useQuery } from '@tanstack/react-query';

/**
 * The « Notes » section an export of this matrix would carry (issue #19): the
 * memo and the open Client discussions, served by the very code the export
 * itself runs, so that the HTML and Excel previews print what the file will.
 *
 * Only asked for while the option is ticked on a format the browser previews
 * itself; the PDF preview is the server's own document and needs none.
 */
export function useExportNotes(matrixId: string, enabled: boolean) {
  return useQuery({
    queryKey: ['export-notes', matrixId],
    queryFn: async (): Promise<ExportNotesSection | null> =>
      (await request(`/matrices/${matrixId}/export-notes`, exportNotesResponseSchema)).section,
    enabled,
    // A note written in another tab since the last preview must show up when
    // the option is ticked again, not after the cache expires.
    staleTime: 0,
  });
}
